import React from 'react'
import Page from '../components/common/page'
import CommandsPage from '../components/views/commands-page'
import MainPage from '../components/views/main-page'
import QuestionsPage from '../components/views/questions-page'
import SettingsPage from '../components/views/settings-page'
import TeamPage from '../components/views/team-page'
import { Route, Redirect } from 'react-router-dom'

import logo from '../logo.svg'
import fetchJSON from '../api/fetch'

const pageContent = () => (
  <header className='App-header'>
    <img src={logo} className='App-logo' alt='logo' />
    <h1 className='App-title'>Welcome to React</h1>
  </header>
)

class Logout extends React.Component {
  state = {
    fetching: true,
    loggedIn: false,
  }
  componentDidMount() {
    fetchJSON
      .get('/logout')
      .then(() => {
        this.setState({
          fetching: false,
        })
      })
      .catch(() => {
        this.setState({
          fetching: false,
        })
      })
  }

  render() {
    const { fetching } = this.state
    return fetching ? <div /> : <Redirect to={{ pathname: '/' }} />
  }
}

const routes = [
  {
    path: '/',
    exact: true,
    component: MainPage,
    page: {},
  },
  {
    path: '/faq',
    exact: true,
    component: QuestionsPage,
    page: {
      title: 'Questions',
    },
  },
  {
    path: '/settings',
    login: true,
    exact: true,
    component: SettingsPage,
    page: {
      title: 'Settings',
    },
  },
  {
    path: '/logout',
    login: true,
    exact: true,
    component: Logout,
    page: {
      title: 'Logging Out',
    },
  },
  {
    path: '/team/:team',
    exact: true,
    component: TeamPage,
    page: {
      title: 'Teams',
    },
  },
  {
    path: '/commands/:name',
    exact: true,
    component: CommandsPage,
    page: {
      title: 'Commands',
    },
  },
  {
    path: '/admin',
    login: true,
    admin: 2,
    exact: true,
    component: pageContent,
    page: {
      title: 'Settings',
    },
  },
]

class WrappedComponent extends React.Component {
  state = {
    fetching: true,
    loggedIn: false,
  }
  componentDidMount() {
    fetchJSON
      .get('/user')
      .then(user => {
        this.setState({
          fetching: false,
          user,
          loggedIn: user && user.id,
        })
      })
      .catch(() => {
        this.setState({
          fetching: false,
          loggedIn: false,
        })
      })
  }
  render() {
    const { user, loggedIn } = this.state
    const { route } = this.props
    const Component = route.component

    return (
      <Page {...route.page} {...{ user, loggedIn }}>
        <Component {...{ user, loggedIn }} {...this.props} />
      </Page>
    )
  }
}

class LoginRequiredRoute extends React.Component {
  state = {
    fetching: true,
    loggedIn: false,
  }
  componentDidMount() {
    fetchJSON
      .get('/user')
      .then(user => {
        this.setState({
          fetching: false,
          user,
          loggedIn: user && user.id,
        })
      })
      .catch(() => {
        this.setState({
          fetching: false,
          loggedIn: false,
        })
      })
  }
  render() {
    const { component: Component, ...rest } = this.props
    const { fetching, user, loggedIn } = this.state
    if (fetching) {
      return null
    } else {
      return (
        <Route
          {...rest}
          render={props =>
            loggedIn ? <Component {...{ user, loggedIn }} {...this.props} /> : <Redirect to={{ pathname: '/' }} />
          }
        />
      )
    }
  }
}

class AdminRequiredRoute extends React.Component {
  state = {
    fetching: true,
    adminLevel: 0,
  }
  componentDidMount() {
    fetchJSON
      .get('/user')
      .then(user => {
        this.setState({
          fetching: false,
          adminLevel: user && user.level,
        })
      })
      .catch(() => {
        this.setState({
          fetching: false,
          admin: false,
        })
      })
  }
  render() {
    const { component: Component, admin = 1, ...rest } = this.props
    const { fetching, adminLevel, user, loggedIn } = this.state
    if (fetching) {
      return null
    } else {
      return (
        <Route
          {...rest}
          render={() =>
            adminLevel && adminLevel >= admin ? (
              <Component {...{ user, loggedIn }} {...this.props} />
            ) : (
              <Redirect to={{ pathname: '/' }} />
            )
          }
        />
      )
    }
  }
}

const getRouteComponent = route => {
  if (route.admin) {
    return AdminRequiredRoute
  }
  if (route.login) {
    return LoginRequiredRoute
  }
  return Route
}

const routeComponents = routes.map(({ component, ...route }) => {
  const RouteComponent = getRouteComponent(route)
  return (
    <RouteComponent
      key={route.path}
      {...route}
      component={() => <WrappedComponent route={{ ...route, component }} />}
    />
  )
})

export default routeComponents



// WEBPACK FOOTER //
// ./src/routes/index.jsx